import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';

var identity = function identity(value) {
  return value;
};
function escape(unescapedString) {
  var regExUnescapedHtml = /[&<>"']/g;
  var htmlEscapes = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
  };
  return unescapedString ? unescapedString.replace(regExUnescapedHtml, function (char) {
    return htmlEscapes[char];
  }) : "";
}
function last(arr) {
  return arr[arr.length - 1];
}
var noop = function noop() {};
function nth(arr, n) {
  if (n < 0) {
    n += arr.length;
  } else if (n >= arr.length) {
    n -= arr.length;
  }

  return arr[n];
}
function groupBy(items, key) {
  return Array.isArray(items) ? items.reduce(function (acc, value) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, value[key], [].concat(_toConsumableArray(acc[value[key]] || []), [value])));
  }, {}) : [];
}

function round(number, precision) {
  var shift = function shift(shiftNumber, exponent) {
    var numArray = ("" + shiftNumber).split("e");
    return +(numArray[0] + "e" + (numArray[1] ? +numArray[1] + exponent : exponent));
  };

  precision = precision === void 0 ? 0 : precision;
  return shift(Math.round(shift(number, +precision)), -precision);
}

var BYTES = 1024;
var SIZES = ["Bytes", "KB", "MB", "GB", "TB"];
var DIVISOR = 6.931471805599453;
function fileSize(size, dec) {
  var exponent = Math.floor(Math.log(parseFloat(size.toString())) / DIVISOR);
  var value = size / Math.pow(BYTES, exponent);

  if (dec) {
    value = round(value, dec);
  } else {
    value = Math.round(value);
  }

  return "".concat(value, " ").concat(SIZES[exponent]);
}
function range(arrayLength) {
  var startAt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return Array.from(Array(arrayLength).keys()).map(function (i) {
    return i + startAt;
  });
}

export { escape, fileSize, groupBy, identity, last, noop, nth, range };
